import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFindingsFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 30 30"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 8a8 8 0 0 1 8-8h14a8 8 0 0 1 8 8v14a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
    />
    <path
      fill="url(#FindingsFull_svg__a)"
      d="M0 8a8 8 0 0 1 8-8h14a8 8 0 0 1 8 8v14a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
      opacity={0.37}
    />
    <path
      fill="url(#FindingsFull_svg__b)"
      fillRule="evenodd"
      d="M13.077 8.963c.808-1.4 2.829-1.4 3.637 0l5.456 9.45c.808 1.4-.202 3.15-1.819 3.15H9.44c-1.617 0-2.627-1.75-1.82-3.15zm1.819 2.195c.434 0 .787.353.787.788v3.542a.788.788 0 0 1-1.575 0v-3.542c0-.435.353-.788.787-.788Zm0 7.697a.788.788 0 1 0 0-1.575.788.788 0 0 0 0 1.575"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="FindingsFull_svg__a"
        x1={18}
        x2={8}
        y1={18}
        y2={17.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
      <linearGradient
        id="FindingsFull_svg__b"
        x1={19.62}
        x2={0.724}
        y1={17.937}
        y2={17.501}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B209" />
        <stop offset={1} stopColor="#FCDB35" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgFindingsFull;
